import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: ()=>import( './Login.vue')
    },
    {
      path: '/register',
      component: ()=>import( './Register.vue')
    },
    {
      path: '/forget',
      component: ()=>import( './Forget.vue')
    },
    
  ]
})




new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
